<template>
  <ViewWrapper class="dashboard_summary_view" :scrollable="true">
    <DashboardSummary />

    <!-- just placeholder by now -->
    <ButtonPill class="dashboard_summary_view__next" :to="{ name: 'dashboard' }" replace>
      {{ $t('ui.continue') }}
    </ButtonPill>
  </ViewWrapper>
</template>

<script>
import ViewWrapper from '../components/ViewWrapper';
import DashboardSummary from '../components/Dashboard/Summary';
import ButtonPill from '../components/ButtonPill';
import store from '../store';

export default {
  name: 'DashboardView',

  components: {
    ViewWrapper,
    DashboardSummary,
    ButtonPill,
  },

  created() {
    store.sendUserDataToDB();
  },
};
</script>

<style lang="scss" scoped>
.dashboard_summary_view {
  background-color: rgba($color-background, $view-overlay-alpha-dark);
  @include helper__box-shadow_overlap($color-background);
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow-x: hidden;

  ::v-deep {
    .view-wrapper__content {
      flex: 1;
    }
  }
}

.dashboard_summary_view__next {
  width: 240px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 30px;
  margin-bottom: calc(30px + env(safe-area-inset-bottom));
}
</style>
